import { v4 as uuidv4 } from 'uuid'
import { instanceQueryService } from '.'
import { functions } from '@/util'
const sysQueryCols = ['query_id', 'session_id', 'transaction_id', 'plan_id', 'state', 'blocked', 'username', 'application_name', 'database_name', 'cluster_name', 'type', 'tags', 'error_code', 'error_message', 'query_text', 'pool_id', 'priority', 'slot', 'num_workers', 'longest_worker_id', 'compile_percent', 'cpu_percent', 'cpu_percent_max', 'num_restart', 'num_error', 'parse_ms', 'wait_parse_ms', 'wait_lock_ms', 'plan_ms', 'wait_plan_ms', 'assemble_ms', 'wait_assemble_ms', 'compile_ms', 'wait_compile_ms', 'acquire_resources_ms', 'run_ms', 'wait_run_cpu_ms', 'wait_run_io_ms', 'wait_run_spool_ms', 'client_ms', 'wait_client_ms', 'total_ms', 'cancel_ms', 'restart_ms', 'wlm_runtime_ms', 'spool_ms', 'cache_efficiency', 'submit_time', 'done_time', 'state_time', 'restart_time', 'io_read_bytes', 'io_write_bytes', 'io_spill_read_bytes', 'io_spill_write_bytes', 'io_network_bytes', 'io_client_read_bytes', 'io_client_write_bytes', 'io_spool_write_bytes', 'rows_inserted', 'rows_deleted', 'rows_returned', 'memory_bytes', 'memory_bytes_max', 'io_spill_space_bytes', 'io_spill_space_bytes_max', 'io_spill_space_granted_bytes', 'memory_estimated_bytes', 'memory_required_bytes', 'memory_granted_bytes', 'memory_estimate_confidence']
const sysLogQueryCols = ['query_id', 'session_id', 'transaction_id', 'plan_id', 'state', 'username', 'application_name', 'database_name', 'cluster_name', 'type', 'tags', 'error_code', 'error_message', 'query_text', 'pool_id', 'priority', 'slot', 'num_workers', 'longest_worker_id', 'compile_percent', 'cpu_percent', 'cpu_percent_max', 'num_restart', 'num_error', 'parse_ms', 'wait_parse_ms', 'wait_lock_ms', 'plan_ms', 'wait_plan_ms', 'assemble_ms', 'wait_assemble_ms', 'compile_ms', 'wait_compile_ms', 'acquire_resources_ms', 'run_ms', 'wait_run_cpu_ms', 'wait_run_io_ms', 'wait_run_spool_ms', 'client_ms', 'wait_client_ms', 'total_ms', 'cancel_ms', 'restart_ms', 'wlm_runtime_ms', 'spool_ms', 'cache_efficiency', 'submit_time', 'done_time', 'state_time', 'restart_time', 'io_read_bytes', 'io_write_bytes', 'io_spill_read_bytes', 'io_spill_write_bytes', 'io_network_bytes', 'io_client_read_bytes', 'io_client_write_bytes', 'io_spool_write_bytes', 'rows_inserted', 'rows_deleted', 'rows_returned', 'memory_bytes', 'memory_bytes_max', 'io_spill_space_bytes', 'io_spill_space_bytes_max', 'io_spill_space_granted_bytes', 'memory_estimated_bytes', 'memory_required_bytes', 'memory_granted_bytes', 'memory_estimate_confidence']
const totalWaitTimeCols = ['wait_parse_ms', 'wait_plan_ms', 'wait_assemble_ms', 'wait_compile_ms', 'wait_lock_ms', 'wait_client_ms', 'wait_run_cpu_ms', 'wait_run_io_ms', 'wait_run_spool_ms']
const waitRunTimeCols = ['wait_run_cpu_ms', 'wait_run_io_ms']

class QueryActivityService {
  async getQueries({ instanceId, filters, columns, time, queryText, pollLimitSeconds, lastStateChangeMs, limit = 10, offset = 0, order, options, stream }) {
    const parameters = {}
    let useTotalWaitTime = false
    let useWaitRunTime = false
    let useJobName = false
    let nextParam = 0

    // Check time; custom times to be done later TODO:
    if (typeof time !== 'object') {
      throw new TypeError('The time parameter for query activity must be an object')
    }

    // Handling of like/ilike
    function handleLikeExpression(value) {
      let v = String(value)
      const hasLeft = v.startsWith('%')
      const hasRight = v.endsWith('%')
      if (!hasLeft) { v = `%` + v }
      if (!hasRight) { v = v + `%` }
      return v
    }

    // Parse time.
    const { timeInMinutes, mode, customTime, clusterName } = time
    const customRange = typeof customTime === 'object' && (customTime.startDate !== null || (customTime.startDate === null && ['today', 'yesterday'].includes(customTime.label)))

    // Make query tags for exclusion of ourself polling.
    let sql = `SET ybd_query_tags TO 'ym-query-activity';\n`

    // Which kind of queries are we dealing with?
    if (mode === 'active') {
      switch (stream) {
        case 'session':
          sql += [
            'WITH activity AS (',
            '  SELECT ss.*, su.name AS session_username, sd.name AS session_dbname',
            '  FROM sys.session ss',
            '  LEFT OUTER JOIN sys.user su ON ss.user_id = su.user_id',
            '  LEFT OUTER JOIN sys.database sd ON ss.database_id = sd.database_id',
            ')',
            ''
          ].join('\n')
          break
        case 'load':
          sql += [
            'WITH activity AS (',
            '  SELECT *, COALESCE(last_activity_time, start_time) AS end_time',
            '  FROM sys.load',
            ')',
            ''
          ].join('\n')
          break
        case 'unload':
          sql += [
            'WITH activity AS (',
            '  SELECT *, COALESCE(last_activity_time, start_time) AS end_time',
            '  FROM sys.unload',
            ')',
            ''
          ].join('\n')
          break
        case 'backup':
          sql += [
            'WITH activity AS (',
            '  SELECT *',
            '  FROM sys.backup',
            ')',
            ''
          ].join('\n')
          break
        case 'restore':
          sql += [
            'WITH activity AS (',
            '  SELECT *',
            '  FROM sys.restore',
            ')',
            ''
          ].join('\n')
          break
        default:
          // Default to Query stream
          sql += [
            'WITH activity AS (',
            '  SELECT active.*, COALESCE(s.client_ip_address, ls.client_ip_address) AS client_ip_address FROM (',
            '    SELECT $(sysQueryCols:name) FROM sys.query',
            '    UNION ALL',
            '    SELECT $(sysQueryCols:name) FROM sys.query_recent',
            '  ) active',
            '  LEFT OUTER JOIN sys.session s ON active.session_id = s.session_id',
            '  LEFT OUTER JOIN sys.log_session ls ON active.session_id = ls.session_id',
            ')',
            ''
          ].join('\n')
          parameters.sysQueryCols = sysQueryCols
          break
      }
    } else {
      switch (stream) {
        case 'session':
          sql += [
            'WITH activity AS (',
            '  SELECT ss.*, su.name AS session_username, sd.name AS session_dbname',
            '  FROM sys.log_session ss',
            '  LEFT OUTER JOIN sys.user su ON ss.user_id = su.user_id',
            '  LEFT OUTER JOIN sys.database sd ON ss.database_id = sd.database_id',
            ')',
            ''
          ].join('\n')
          break
        case 'load':
          sql += [
            'WITH activity AS (',
            '  SELECT *, end_time AS last_activity_time',
            '  FROM sys.log_load',
            ')',
            ''
          ].join('\n')
          break
        case 'unload':
          sql += [
            'WITH activity AS (',
            '  SELECT *, end_time AS last_activity_time',
            '  FROM sys.log_unload',
            ')',
            ''
          ].join('\n')
          break
        case 'backup':
          sql += [
            'WITH activity AS (',
            '  SELECT *',
            '  FROM sys.log_backup',
            ')',
            ''
          ].join('\n')
          break
        case 'restore':
          sql += [
            'WITH activity AS (',
            '  SELECT *',
            '  FROM sys.log_restore',
            ')',
            ''
          ].join('\n')
          break
        default:

          // Default to Query stream but deal with 2hr "recent" separate from historical.
          if (!customRange && timeInMinutes <= 120) {
            sql += [
              'WITH activity AS (',
              '  SELECT recent.*, s.client_ip_address',
              '  FROM sys.query_recent recent',
              '  LEFT OUTER JOIN sys.log_session s ON recent.session_id = s.session_id',
              ')',
              ''
            ].join('\n')
          } else {
            sql += [
              'WITH activity AS (',
              '  SELECT historical.*, s.client_ip_address',
              '  FROM sys.log_query historical',
              '  LEFT OUTER JOIN sys.log_session s ON historical.session_id = s.session_id',
              ')',
              ''
            ].join('\n')
          }
          break
      }
    }

    function buildSelectColumns() {
      const result = []

      // queries always include query_id
      if (stream === 'query') { result.push('query_id') }

      for (const c of columns) {

        if (c.field === 'job_name') {
          useJobName = true
          result.push('client_hostname', 'username', 'database_name')
          continue
        }

        if (c.field === 'total_wait_time_ms') {
          useTotalWaitTime = true
          result.push(...totalWaitTimeCols)
          continue
        }

        if (c.field === 'wait_run_time_ms') {
          useWaitRunTime = true
          result.push(...waitRunTimeCols)
          continue
        }

        result.push(c.field)
      }

      return result
    }

    // Compose sql.
    parameters.columns = buildSelectColumns()
    sql += 'SELECT $(columns:name)\nFROM activity'

    // Time predicate (customRange vs minutes)
    if (customRange) {
      parameters.from_ts = customTime.startDate
      parameters.to_ts = customTime.endDate

      if (stream === 'query') {
        // COALESCE(state_time, submit_time) BETWEEN ... and OR active tail
        let pred = `COALESCE(state_time, submit_time) BETWEEN $(from_ts)::timestamp AND $(to_ts)::timestamp`
        if (mode === 'active') {
          pred = `(${pred} OR (done_time IS NULL AND state NOT IN ('restart error','restart user') AND total_ms > 100))`
        }
        sql += `\nWHERE ${pred}`
      } else {
        // Other streams use start_time BETWEEN ...
        sql += `\nWHERE start_time BETWEEN $(from_ts)::timestamp AND $(to_ts)::timestamp`
      }
    } else {
      // Minutes path
      parameters.time_minutes = timeInMinutes

      if (stream === 'query') {
        let pred = `COALESCE(state_time, submit_time) > current_timestamp - ($(time_minutes) * interval '1 minute')`
        if (mode === 'active') {
          pred = `(${pred} OR (done_time IS NULL AND state NOT IN ('restart error','restart user') AND total_ms > 100))`
        }
        sql += `\nWHERE ${pred}`
      } else {
        sql += `\nWHERE start_time > current_timestamp - ($(time_minutes) * interval '1 minute')`
      }
    }

    // Query text
    if (queryText) {
      parameters.query_text = handleLikeExpression(queryText)
      sql += `\nAND query_text ILIKE '$(query_text:value)'`
    }

    function buildFilterConditions() {
      let result = ''

      const groupFilters = functions.groupBy(filters || [], 'value')
      const sk = s => String(s).replace(/[^a-zA-Z0-9_]/g, '_')
      Object.keys(groupFilters).forEach((key) => {
        const items = groupFilters[key] || []

        if (/_ms$/.test(key)) {
          const parts = []
          items.forEach((filter) => {
            const base = `${sk(key)}_${nextParam++}`
            // primary
            const pSize = filter.option.value.primarySize === 'miliseconds'
              ? parseInt(filter.option.value.primaryTime)
              : parseInt(filter.option.value.primaryTime) * 1000
            parameters[`${base}_a`] = pSize

            if (['less_than', 'more_than'].includes(filter.option.value.compare)) {
              const op = filter.option.value.compare === 'less_than' ? '<' : '>'
              parts.push(`\n${filter.value} ${op} $(${base}_a)`)
            } else {
              const sSize = filter.option.value.secondarySize === 'miliseconds'
                ? parseInt(filter.option.value.secondaryTime)
                : parseInt(filter.option.value.secondaryTime) * 1000
              parameters[`${base}_b`] = sSize
              parts.push(`\n${filter.value} >= $(${base}_a) AND ${filter.value} <= $(${base}_b)`)
            }
          })
          if (parts.length) { result += `\nAND (${parts.join(' OR ')})` }
        } else if (/_bytes$/.test(key)) {
          const parts = []
          items.forEach((filter) => {
            let size = parseInt(filter.option.value.value)
            const unit = (filter.option.value.size || '').toLowerCase()
            if (unit === 'kb') { size *= 1024 } else if (unit === 'mb') { size *= 1024 * 1024 } else if (unit === 'gb') { size *= 1024 * 1024 * 1024 }

            const base = `${sk(key)}_${nextParam++}`
            parameters[`${base}`] = size

            const cmpMap = {
              greater_than: '>',
              greater_than_or_equal_to: '>=',
              less_than: '<',
              less_than_or_equal_to: '<=',
              equal_to: '='
            }
            const cmp = cmpMap[filter.option.value.compare]
            if (cmp) { parts.push(`\n${filter.value} ${cmp} $(${base})`) }
          })
          if (parts.length) { result += `\nAND (${parts.join(' OR ')})` }
        } else if (/(efficiency|num_|_count|_percent|cpu)/.test(key)) {
          const parts = []
          items.forEach((filter) => {
            const val = parseFloat(filter.option.value.value)
            const base = `${sk(key)}_${nextParam++}`
            parameters[`${base}`] = isNaN(val) ? 0 : val

            const cmpMap = {
              greater_than: '>',
              greater_than_or_equal_to: '>=',
              less_than: '<',
              less_than_or_equal_to: '<=',
              equal_to: '='
            }
            const cmp = cmpMap[filter.option.value.compare]
            if (cmp) { parts.push(`\n${filter.value} ${cmp} $(${base})`) }
          })
          if (parts.length) { result += `\nAND (${parts.join(' OR ')})` }
        } else {
          // String comparisons
          const parts = []
          let useAnd = false

          items.forEach((filter) => {
            const operator = filter?.option?.compare || '='
            if (operator === '!=') { useAnd = true }

            if (operator === 'IS NULL' || operator === 'IS NOT NULL') {
              parts.push(`\n${filter.value} ${operator}`)
              return
            }

            if (operator === 'Like' || operator === 'Not Like') {
              const base = `${sk(key)}_like_${nextParam++}`
              parameters[base] = handleLikeExpression(filter.option.value)
              parts.push(`\n${filter.value} ${operator === 'Like' ? 'LIKE' : 'NOT LIKE'} $(${base})`)
              return
            }

            const base = `${sk(key)}_str_${nextParam++}`
            parameters[base] = filter.option.value
            parts.push(`\n${filter.value} ${operator} $(${base})`)
          })

          if (parts.length) { result += `\nAND (${parts.join(useAnd ? ' AND ' : ' OR ')})` }
        }
      })

      return result
    }

    // Make filters into WHERE clause.
    const groupFilters = buildFilterConditions()
    if (groupFilters) {
      sql += '\n' + groupFilters
    }

    // Are we doing a query activity?
    if (stream === 'query') {

      // Do filters if supplied.
      const { systemWork, automaticFlush, session } = (options || {})
      if (systemWork) {
        sql += `\nAND username NOT LIKE 'sys_ybd_%'`
      }
      if (automaticFlush) {
        sql += `\nAND type NOT IN ('yflush', 'ycopy')`
      }
      if (session) {
        sql += `\nAND type NOT IN ('set', 'show', 'reset')`
      }

      // Exclude YM itself.
      sql += `\nAND (tags IS NULL OR tags != 'ym-query-activity')`
    }

    if (order) {
      if (order.column === 'job_name') {
        parameters.orderColumn = "client_hostname||' / '||username||' / '|| database_name"
      } else {
        parameters.orderColumn = order.column
      }
      sql += `\nORDER BY $(orderColumn:name) ${order.order} NULLS LAST`
    }

    if (limit) {
      parameters.limit = limit
      sql += '\nLIMIT $(limit)'
    }

    parameters.offset = offset
    sql += '\nOFFSET $(offset)'

    // Add cluster.
    if (!!clusterName && mode !== 'active') {
      parameters.clusterName = clusterName
      sql = 'USE CLUSTER $(clusterName:name);\n' + sql
    }

    // Return result rows.
    const queryOptions = mode === 'active' ? { parameters } : { parameters, asyncTimeout: 30 * 1000 }
    const result = await instanceQueryService.sql(instanceId, 'yellowbrick', sql, queryOptions)
    let rows = result.rows

    // Add missing rows
    result.columns.forEach((col) => {
      rows.map((row) => {
        if (row[col.label] === undefined) {
          row[col.label] = row[col.name]
        }
        return row
      })
    })

    if (useTotalWaitTime) {
      rows = rows.map((row) => {
        row.total_wait_time_ms = totalWaitTimeCols.reduce((acc, colName) => {
          return acc + (row[colName] || 0)
        }, 0)
        return row
      })
    }
    if (useWaitRunTime) {
      rows = rows.map((row) => {
        row.wait_run_time_ms = waitRunTimeCols.reduce((acc, colName) => {
          return acc + (row[colName] || 0)
        }, 0)
        return row
      })
    }
    if (useJobName) {
      rows = rows.map((row) => {
        row.job_name = (row.client_hostname && row.username && row.database_name && `${row.client_hostname} / ${row.username} / ${row.database_name}`) || 'n/a'
        return row
      })
    }
    return {
      sql: async () => await instanceQueryService.formatQuery(sql, parameters),
      rows
    }
  }

  async getColumnTopUsage({ instanceId, column, time, limit, options }) {
    // Validate time
    if (typeof time !== 'object') {
      throw new TypeError('The time parameter for query activity must be an object')
    }

    // Unpack filters
    const { systemWork, automaticFlush, session } = (options || {})
    let condition = ''
    if (systemWork) { condition += `\nAND username NOT LIKE 'sys_ybd_%'` }
    if (automaticFlush) { condition += `\nAND type NOT IN ('yflush', 'ycopy')` }
    if (session) { condition += `\nAND type NOT IN ('set', 'show', 'reset')` }

    // Parse time
    const { timeInMinutes, mode, customTime } = time
    if (customTime.startDate !== null || (customTime.startDate === null && ['today', 'yesterday'].includes(customTime.label))) {
    // custom windows handled elsewhere if needed
    }

    // Source query
    const sourceQuery = mode === 'active'
      ? 'select $(columns:name) from sys.query union all select $(columns:name) from sys.query_recent'
      : 'select $(columns:name) from sys.log_query'

    // Parameters
    const parameters = {
      tag: 'ym-query-activity',
      limit_val: limit || 10,
      column_name: column, // identifier
      columns: mode === 'active' ? sysQueryCols : sysLogQueryCols
    }

    // Two variants depending on timeInMinutes
    let innerWhere
    if (timeInMinutes) {
      parameters.time_minutes = timeInMinutes
      innerWhere = `COALESCE(state_time, submit_time) > current_timestamp - ($(time_minutes) * interval '1 minute') ${condition}`
    } else {
      innerWhere = `(tags IS NULL OR tags != $(tag)) ${condition}`
    }

    // Compose SQL
    const sql = `
      SET ybd_query_tags TO $(tag);
      SELECT $(column_name:name), COUNT(*)
      FROM (
        ${sourceQuery}
      ) queries
      WHERE ${innerWhere}
      GROUP BY 1
      ORDER BY 2 DESC
      LIMIT $(limit_val)
    `

    // Execute with parameters
    const result = await instanceQueryService.sql(instanceId, 'yellowbrick', sql, { parameters, asyncTimeout: 30 * 1000 })
    return result.rows
  }

  async pollQueryStates({ instanceId, stateTimeMs, pollDurationMs, pollBufferDurationMs }) {
    if (isNaN(stateTimeMs) || stateTimeMs === -Infinity || stateTimeMs === Infinity) {
      stateTimeMs = 1
    }
    const sql = 'SELECT query_id, state, pool_id, slot, cluster_name, extract(epoch from submit_time) * 1000 as submit_time, extract(epoch from execution_time) * 1000 as execution_time, extract(epoch from state_time) * 1000 as state_time, extract(epoch from restart_time) * 1000 as restart_time, extract(epoch from done_time) * 1000 as done_time, num_restart, run_ms, memory_granted_bytes FROM sys.query_poll_state($(stateTimeMs), NULL, NULL, $(pollDurationMs), $(pollBufferDurationMs))'
    const asyncPoll = instanceQueryService.sql(instanceId, 'yellowbrick', sql, { parameters: { stateTimeMs, pollDurationMs, pollBufferDurationMs }, batchKey: uuidv4() })
    const result = await asyncPoll
    return result.rows || []
  }

  async cancelQuery({ instanceId, queryId }) {
    const sql = 'CANCEL $(queryId)'
    const result = await instanceQueryService.sql(instanceId, 'yellowbrick', sql, { parameters: { queryId } })
    return result
  }

  async terminateSession({ instanceId, sessionId }) {
    const sql = 'select yb_terminate_session($(sessionId))'
    const result = await instanceQueryService.sql(instanceId, 'yellowbrick', sql, { parameters: { sessionId } })
    return result
  }
}

const queryActivityService = new QueryActivityService()
export default queryActivityService
